import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedServicetypesReducer(state = initialState.selectedServicetypes, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_SERVICETYPES_SUCCESS:
      return action.selectedServicetypes;
    default:
      return state;
  }
}
